/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import simcardStyle from 'assets/jss/adescom/adescomStyle';
import TariffsRange from 'components/Adescom/SimpleSelectRest';
import MsisdnPoolChooseDialog from 'views/msisdn-pools/Dialog/MsisdnPoolChooseDialog';
import ActionButton from 'components/Buttons/CustomTextButton';
import { FormGeneralHelper } from 'helpers/FormGeneral';
import { simCardActions, simCardConstants } from 'modules/simcard/actions';
import { SimCardEntity } from 'modules/simcard/Entity';
import { notificationConstants } from '../../../modules/notifications/notifications';
import I18n from '../../../components/Translate/I18n';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { ProductChangeLanguage } from '../../SimCard/component/ProductChangeLanguage';

class IccidParing extends PureComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            iccid: this.props.iccid,
            entity: {
                tariffPlanId: null,
                msisdn: null,
                languageId: -1,
                client: { platformResellerId: this.props.iccid.ownerPlatformResellerId },
            },
            entityStatus: {
                tariffPlanId: null,
                msisdn: null,
            },
            autoactivationdate: null,
            msisdn: null,
            openMsisdn: false,
            msisdnItem: null,
            showAccept: false,
            mvnoOperatorSetup: null,
            isPrepaid: false,
        };
    }

    componentDidMount() {
        this.loadMnoOperatorSetup();
    }

    loadMnoOperatorSetup = () => {
        const { iccid } = this.state;
        const { dispatch } = this.props;
        if (iccid) {
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getUrl('/mvno_operator_setups'),
                'get_mvno_opertor_setup_list_iccid_parring',
                [
                    { name: 'operatorType', value: iccid.operatorType },
                    { name: 'typeValue', value: 'TARIFF' },
                    { name: 'platformResellerId', value: iccid.ownerPlatformResellerId },
                ],
                [{ name: 'displayName', value: 'asc' }],
                (response) => {
                    let data = [];
                    for (let i = 0; i < response['hydra:member'].length; i++) {
                        data.push({
                            name: response['hydra:member'][i].displayName,
                            id: response['hydra:member'][i].constName,
                            prepaid: response['hydra:member'][i].prepaid,
                        });
                    }
                    this.setState({
                        mvnoOperatorSetup: { 'hydra:member': data },
                    });
                },
                { dispatchAfterCallback: false, propagateDataToCallback: true }
            );
        }
    };

    selectFunc = (e, stateName, require) => {
        const { mvnoOperatorSetup } = this.state;
        const value = e.target.value;
        let isPrepaid = false;
        if (mvnoOperatorSetup) {
            for (let i = 0; i < mvnoOperatorSetup['hydra:member'].length; i++) {
                let k = mvnoOperatorSetup['hydra:member'][i].id;
                if (mvnoOperatorSetup['hydra:member'][i].id === value) {
                    isPrepaid = mvnoOperatorSetup['hydra:member'][i].prepaid;
                }
            }
        }
        this.setState((prevState) => ({
            entity: {
                ...prevState.entity,
                [stateName]: value,
            },
            entityStatus: {
                ...prevState.entityStatus,
                [stateName]: null,
            },
            isPrepaid: isPrepaid,
        }));
    };

    openGetMsisdnDialog = () => {
        this.setState({ openMsisdn: true });
    };

    closeGetMsisdnDialog = () => {
        this.setState({ openMsisdn: false });
    };

    callBackSetMsisdn = (v) => {
        const { iccid } = this.props;
        this.setState(
            (prevState) => ({
                showAccept: true,
                msisdn: v.msisdn,
                isPrepaid: false,
                tariffPlanId: null,
                entity: {
                    ...prevState.entity,
                    msisdn: v.msisdn,
                },
            }),
            this.closeGetMsisdnDialog
        );
    };

    saveAndActivateSimCard = () => {
        const { dispatch, iccid } = this.props;
        const { isPrepaid, entity, portingNumber } = this.state;
        const product = SimCardEntity;
        product.msisdn = entity.msisdn;
        product.tariffPlanId = entity.tariffPlanId;
        product.iccid = iccid.iccid;
        product.imsi = iccid.imsi;
        product.isPorted = portingNumber;
        product.isPrepaid = isPrepaid;
        product.languageId = entity.languageId;

        dispatch(
            simCardActions.post(
                FormGeneralHelper.getUrl('/sim_cards'),
                product,
                simCardConstants.SIM_CARD_ADD,
                {
                    onSuccess: (data) => {
                        this.props.refreshPage();
                    },
                    onError: (error) => {
                        dispatch({
                            type: notificationConstants.ERROR,
                            error: error,
                            status: error.status,
                        });
                    },
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            )
        );
    };

    change = (e, stateName, type, require, maxValue, minValue) => {
        FormGeneralHelper.validateForms(this, e, stateName, type, require, maxValue, minValue, () => {
            if (this.state.entity.msisdn.length > 8 && this.state.entity.msisdn.length < 12) {
                this.setState({ showAccept: true });
            } else {
                this.setState({ showAccept: false });
            }
        });
    };

    render() {
        const { entity, showAccept, msisdn, mvnoOperatorSetup } = this.state;
        const { classes } = this.props;

        return (
            <GridContainer>
                <GridItem xs={6}>{msisdn && <I18n trans="simcard:add.choosen_msisdn" valueObject={{ msisdn: msisdn }} />}</GridItem>
                <GridItem xs={12} />
                <GridItem xs={6}>
                    {showAccept && (
                        <TariffsRange
                            callback={this.selectFunc}
                            restElements={mvnoOperatorSetup}
                            stateName="tariffPlanId"
                            idState="tariffPlanId"
                            idSelected={entity.tariffPlanId}
                            propKey="id"
                            required={false}
                            propValue="name"
                            emptyLabel="general:common.empty_label"
                            label="pools:sim.service_profile"
                        />
                    )}
                </GridItem>
                <GridItem xs={12}>
                    <ActionButton callback={this.openGetMsisdnDialog} callbackParam={{}} label="simcard:edit.choose_new_msisdn" size="sm" />
                    {showAccept && entity.client.platformResellerId && (
                        <>
                            <ActionButton callback={this.saveAndActivateSimCard} callbackParam={{}} label="simcard:add.register_sim_card" size="sm" />
                            <ProductChangeLanguage
                                isCreate={true}
                                product={entity}
                                reload={(languageId) => {
                                    this.setState({ entity: { ...entity, languageId: languageId } });
                                }}
                                classes={classes}
                            />
                        </>
                    )}
                    <MsisdnPoolChooseDialog
                        callBackSetMsisdn={this.callBackSetMsisdn}
                        open={this.state.openMsisdn}
                        callbackClose={this.closeGetMsisdnDialog}
                        platformResellerId={this.state.iccid.ownerPlatformResellerId}
                    />
                </GridItem>
            </GridContainer>
        );
    }
}

IccidParing.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return {};
};
const enhance = compose(connect(mapStateToProps), withStyles(simcardStyle));
const Enhance = enhance(IccidParing);
export default Enhance;
